import ExaminationResults from './ExaminationResults';

export default ExaminationResults;
